import React from 'react';

const index = () => {
  return (
    <footer className='footer'>
      <p>
        Made by{' '}
        <a
          href='https://github.com/faisalamin001'
          target='_blank'
          rel='noreferrer'
        >
          Faisal Amin
        </a>
      </p>
    </footer>
  );
};

export default index;
